import React, { createContext, ReactNode, useContext, useState } from 'react';

type EditedFieldsState = Record<string, boolean>;

interface UserEditedFieldsContextType {
  editedFields: EditedFieldsState;
  setFieldAsEdited: (fieldName: string) => void;
}

const UserEditedFieldsContext = createContext<
  UserEditedFieldsContextType | undefined
>(undefined);

export const UserEditedFieldsProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [editedFields, setEditedFields] = useState<EditedFieldsState>({});

  const setFieldAsEdited = (fieldName: string) => {
    setEditedFields((prev) => ({ ...prev, [fieldName]: true }));
  };

  return (
    <UserEditedFieldsContext.Provider
      value={{ editedFields, setFieldAsEdited }}
    >
      {children}
    </UserEditedFieldsContext.Provider>
  );
};

export const useUserEditedFieldsContext = (): UserEditedFieldsContextType => {
  const context = useContext(UserEditedFieldsContext);
  if (!context) {
    throw new Error(
      'useUserEditedFieldsContext must be used within a UserEditedFieldsProvider'
    );
  }
  return context;
};
